module.exports = __webpack_public_path__ + "static/media/ra-logo-color.fc68366a.svg";